// extracted by mini-css-extract-plugin
export default {"main":"nda-z"};